export default {
    share: {
        copySuccess: 'Copy Success'
    }
};


